import { ImportConflictAction } from "types/misc";

//Excel Export
export interface ExcelExportRequestParams {
  exportAll: boolean;
  propertyIds: string[] | null;
  exportSubproperties: boolean;
  tableIds: string[] | null;
  exportIds: boolean;
  exportPropertiesForAllTables: boolean;
  exportMetadata: boolean;
  exportPVAs: boolean;
  exportPropertyPriorities: boolean;
  exportCandidateSelectionDatabaseXml: boolean;
  exportProductlineMetadataXml: boolean;
  buildTableOfContents: boolean;
  zipIfSingleFile: boolean;
}

export const defaultExcelExportRequestParams: ExcelExportRequestParams = {
  exportAll: false,
  propertyIds: null,
  exportSubproperties: false,
  tableIds: null,
  exportIds: false,
  exportPropertiesForAllTables: false,
  exportMetadata: false,
  exportPVAs: false,
  exportPropertyPriorities: false,
  exportCandidateSelectionDatabaseXml: false,
  exportProductlineMetadataXml: false,
  buildTableOfContents: false,
  zipIfSingleFile: false,
};

//Excel Import
export interface ExcelImportRequestParams {
  /**
   * List of Excel worksheet names to import. If null/undefined, import all.
   */
  worksheetNames?: string[] | null;

  /**
   * Import all properties found on available worksheets.
   */
  importProperties: boolean;

  /**
   * If replacing an existing parent property, delete any unmatched subproperties.
   * (Existing subproperties that do not appear in the import will be deleted.)
   */
  deleteUnmatchedSubproperties: boolean;

  /**
   * Import all tables found on available worksheets.
   */
  importTables: boolean;

  /**
   * How to resolve conflicts when the imported artifact already exists:
   * - ABORT: do not import the item
   * - NEW: import as a new item with new id and a modified name (for properties)
   * - REPLACE: replace the existing artifact, re‑using ids
   */
  conflictAction: ImportConflictAction;
}

export const defaultExcelImportRequestParams: ExcelImportRequestParams = {
  worksheetNames: null,
  importProperties: true,
  deleteUnmatchedSubproperties: false,
  importTables: true,
  conflictAction: ImportConflictAction.Abort,
};
